import React from 'react';
import componentProps, { ComponentProps } from '../../../../helpers/componentProps';
import { applyComponentTheme } from '../../../../theme';
import { CardSection as CardSectionType } from '../../types';
import {
  CardSectionContainer,
  CardSectionCta,
  CardSectionHeading,
  CardSectionText,
} from './styles';

type CardSectionProps = CardSectionType & ComponentProps;

const CardSection: React.FC<CardSectionProps> = ({ heading, text, cta, ...props }) => (
  <CardSectionContainer {...componentProps(props)}>
    <CardSectionHeading>{heading}</CardSectionHeading>
    <CardSectionText>{text}</CardSectionText>
    {cta && <CardSectionCta cta={cta} type="button" background="dark" />}
  </CardSectionContainer>
);

export default applyComponentTheme(CardSection, 'CardSection');
